import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, Card, Row, Button } from 'reactstrap';
// import { Link } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/database';
import './App.css';


class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: undefined,
            lastName: undefined,
            region: undefined,
            club: undefined,
            rating: undefined,
            name: undefined,
            newUser: true,
            errors: {
                firstName: '',
                lastName: '',
            }
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        let { firstName, lastName, region, club, rating } = this.state;
        this.setState({ name: firstName + ' ' + lastName })
        let dbRef = firebase.database().ref("/user").child(this.props.user.uid);
        dbRef.set({
            firstName: firstName,
            lastName: lastName,
            region: region,
            club: club,
            rating: rating,
            name: firstName + ' ' + lastName,
            scoreHA: '0',
            scoreHB: '0',
            scoreC: '0',
            scoreD: '0',
            newUser: false
        })

        var form = document.getElementById('eventdetail');
        form.style.display = 'none';
    }




    render() {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Form id='eventdetail' style={{ padding: '3em'}}>
                    <Card style={{ padding: '1em' }} className='signup'>
                        <Row>
                            <FormGroup style={{ paddingLeft: '1em' }}>
                                <Label> First Name </Label>
                                <Input value={this.state.firstName} type='text' name='firstName' id='firstName' onChange={this.handleChange} placeholder="Enter First Name"></Input>
                            </FormGroup>
                            <FormGroup style={{ paddingLeft: '1em' }}>
                                <Label> Last Name </Label>
                                <Input value={this.state.lastName} type='text' name='lastName' id='lastName' onChange={this.handleChange} placeholder="Enter Last Name"></Input>
                            </FormGroup>
                        </Row>
                        <FormGroup>
                            <Label> Region </Label>
                            <Input value={this.state.region} type='select' name='region' id='region' onChange={this.handleChange}>

                                <option> Please Select </option>
                                <option> Alaska </option>
                                <option> Big Sky </option>
                                <option> Carolina </option>
                                <option> Capitol</option>
                                <option> Deep South </option>
                                <option> Delmarva </option>
                                <option> Great Lakes </option>
                                <option> Hawaii </option>
                                <option> Heartland </option>
                                <option> Inland Empire </option>
                                <option> Intermountain </option>
                                <option> Lake Shore </option>
                                <option> Maryland </option>
                                <option> Metropolitan </option>
                                <option> Midsouth </option>
                                <option> Midwest </option>
                                <option> New Jersey </option>
                                <option> North Central Prairie </option>
                                <option> Northeast </option>
                                <option> Northern Lakes </option>
                                <option> Northwest </option>
                                <option> Old Dominion </option>
                                <option> Oregon </option>
                                <option> Red River </option>
                                <option> Rio Grande </option>
                                <option> Rocky Mountain </option>
                                <option> Southwest </option>
                                <option> Sunshine </option>
                                <option> Tri-State </option>
                                <option> Virginia </option>
                                <option> Camino Real </option>
                                <option> Central New England </option>
                                <option> Eastern Pennsylvania </option>
                                <option> Middle California </option>
                                <option> Sierra Pacific </option>
                                <option> South </option>
                                <option> Southern California</option>
                                <option> Upper York - Upper Connecticut </option>
                                <option> Western New England </option>
                                <option> Western New York </option>
                                <option> White Mountain </option>
                                <option> INTERNATIONAL </option>

                            </Input>
                        </FormGroup>

                        <FormGroup>
                                <Label> Club </Label>
                                <Input value={this.state.club} type='text' name='club' id='club' onChange={this.handleChange} placeholder="Enter Club"></Input>
                            </FormGroup>

                        {/* <FormGroup>
                            <Label> Club </Label>
                            <Input value={this.state.club} type='select' name='club' id='club' onChange={this.handleChange}>
                                <option> Please Select </option>
                                <option> National Youth Board </option>
                            </Input>
                        </FormGroup> */}
                        <FormGroup>
                            <Label> Certification </Label>
                            <Input value={this.state.rating} type='select' name='rating' id='rating' onChange={this.handleChange}>
                                <option> Please Select </option>
                                <option> D-1 </option>
                                <option> D-2 </option>
                                <option> D-3 </option>
                                <option>C-1 </option>
                                <option> C-2 </option>
                                <option> C+ </option>
                                <option> H-B </option>
                                <option>C-3</option>
                                <option> B </option>
                                <option> H+ </option>
                                <option> H-A </option>
                                <option> Unrated </option>
                            </Input>
                        </FormGroup>
                        <Button color='primary' onClick={this.handleSubmit}>  Submit </Button>
                    </Card>
                </Form>
            </div>


        )
    }

}

export default Auth